
/*import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
export default {
  name: "RecapSignOk",
   data () {
    return {
      contactEmail:null,
      loading:false

    }
  },
  mounted: function () {
    this.contactEmail = this.$globalService.getSessionSouscription().contactEmail
  },
  methods: {
    prendreRendezvous: function() {
      if(this.$globalService.getSessionSouscription().active_rdv == true && this.$globalService.getSessionSouscription().serviceChoisi 
      && this.$globalService.getSessionSouscription().serviceChoisi.type !='mobile' && this.$globalService.checkDateCommercialisation(this.$globalService.getSessionSouscription().serviceChoisi)  ){
        this.$router.push({name: 'RdvCreneaux'});   // désactivation de la réservation des rdv le 06/01/2021 pour vérification
      }else
        this.$router.push({name: 'Final'});
    }
  }
}